import Home from "./Home";
import GlobalCustomization from "./GlobalCustomization";
import LocationGroupsCustomization from "./LocationGroupsCustomization";
import SaasCustomization from "./SaasCustomization";
const routes = [
  {
    key: "home",
    route: "/",
    component: <Home />,
  },
  {
    key: "customization",
    route: "/:type",
    component: <GlobalCustomization />,
  },
  {
    key: "location_groups",
    route: "/location_groups/*",
    component: <LocationGroupsCustomization />,
  },
  {
    key: "saas_customization",
    route: "/saas_customization/*",
    component: <SaasCustomization />,
  },
];

export default routes;
